import { useMemo } from 'react';

export interface DraftViewState { import_id?: string; step?: string; mode?: string }
export function useBulkImportDraft(propertyId: string) {
  const key = `intrlock.bulk-import.${propertyId}`;
  const restored = useMemo<DraftViewState>(() => {
    try {
      const raw = JSON.parse(localStorage.getItem(key) || '{}');
      return { import_id: typeof raw.import_id === 'string' ? raw.import_id : undefined, step: typeof raw.step === 'string' ? raw.step : undefined, mode: typeof raw.mode === 'string' ? raw.mode : undefined };
    } catch { return {}; }
  }, [key]);
  return {
    restored,
    save: (state: DraftViewState) => localStorage.setItem(key, JSON.stringify({ import_id: state.import_id, step: state.step, mode: state.mode })),
    clear: () => localStorage.removeItem(key),
  };
}
